import { COMPONENT_VALUE_TYPES as types, COMPONENT_COLOR_THEMES, REGIONS } from 'shared/constants';

const propsSchema = [
  {
    key: 'region',
    label: 'Region',
    type: types.ENUM,
    options: REGIONS
  },
  {
    key: 'color_theme',
    label: 'Color Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES
  },
  {
    key: 'scroll_in_animation',
    label: 'Scroll-In Animation',
    type: types.BOOLEAN
  },
  {
    key: 'expandable',
    label: 'Expandable',
    type: types.BOOLEAN
  },
  {
    key: 'title',
    label: 'Title',
    type: types.TEXT
  },
  {
    key: 'subtitle',
    label: 'Subtitle',
    type: types.TEXT
  },
  {
    key: 'interested_in_reserve_checkbox',
    label: 'Interested in Reserve Checkbox',
    type: types.BOOLEAN
  },
  {
    key: 'form_fields',
    label: 'Form Fields',
    type: types.OBJECT,
    children: [
      {
        key: 'email',
        label: 'Email Field',
        type: types.TEXT
      },
      {
        key: 'first_name',
        label: 'First Name Field',
        type: types.TEXT
      },
      {
        key: 'last_name',
        label: 'Last Name Field',
        type: types.TEXT
      },
      {
        key: 'zipcode',
        label: 'Zipcode Field',
        type: types.TEXT
      },
      {
        key: 'interested_in_reserve',
        label: 'Interested in Reserve Message',
        type: types.TEXT
      },
      {
        key: 'reserve_now',
        label: 'Reserve Button',
        type: types.TEXT
      },
      {
        key: 'subscribe',
        label: 'Subscribe Button',
        type: types.TEXT
      },
      {
        key: 'error_msg',
        label: 'Error Message',
        type: types.TEXT
      },
      {
        key: 'subscribe_in_china',
        label: 'Subscribe in China Message',
        type: types.TEXT
      },
      {
        key: 'success_message',
        label: 'Success Subscribe Message',
        type: types.TEXT
      },
      {
        key: 'continue_to_reserve',
        label: 'Continue to Reserve Message',
        type: types.TEXT
      },
      {
        key: 'blocked_country_message',
        label: 'Blocked Country Message',
        type: types.TEXT
      }
    ]
  },
  {
    key: 'redirect_link',
    label: 'Redirect Link',
    type: types.TEXT
  },
  {
    key: 'always_show_widget',
    label: 'Always show this widget - ignore any global settings',
    type: types.BOOLEAN
  },
  {
    key: 'useEventStyle',
    label: 'Use event style',
    type: types.BOOLEAN
  },
];

const defaultProps = {
  color_theme: 'DARK',
  scroll_in_animation: true,
  region: 'US',
  expandable: true,
  title: 'Get the latest news and important updates from FF',
  subtitle: 'Sign up for the latest of the FF 91 Futurist and other news about Faraday Future',
  interested_in_reserve_checkbox: false,
  form_fields: {
    email: 'Email Address',
    first_name: 'First Name',
    last_name: 'Last Name',
    zipcode: 'Zipcode',
    interested_in_reserve: 'I\'m interested in reserving an FF 91',
    reserve_now: 'Preorder Now',
    subscribe: 'Subscribe',
    error_msg: 'Something went wrong. Please try again later.',
    subscribe_in_china: 'Please subscribe on our China region site.',
    success_message: 'Your subscription has been confirmed. You’ll receive the latest news and updates from Faraday Future.',
    continue_to_reserve: 'If you would like to preorder an FF 91 please click the button below.',
    blocked_country_message: 'Thank you for your interest in Faraday Future. Subscription is not open to your country at this time. Please follow Faraday Future on social media for the latest vehicle and company updates.'
  },
  redirect_link: '/cn/subscribe',
  override_hide_subscribe_flag: false,
  useEventStyle: false,
};

export default {
  title: 'Subscribe',
  id: 'Subscribe',
  propsSchema,
  defaultProps
};
